import { Injectable, EventEmitter } from '@angular/core';
import {Event, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})





export class SidebarMenuService {
  public appDrawer: any;
  public currentUrl = new BehaviorSubject<string>(undefined);

  drawerSibebarEvent = new Subject<any>();

  constructor(private router: Router) {

  }




}







